namespace $.$$ {
	$mol_style_define( $shm_dashboard_admin_monitoring, {
		width: 0,
		minWidth: 0,
		flex: { grow: 1, shrink: 1, basis: 0 },
		overflow: 'hidden',
		Controls: {
			alignItems: 'center',
			gap: $mol_gap.text,
			padding: { left: $mol_gap.block, right: $mol_gap.block, top: $mol_gap.block },
			flexWrap: 'wrap',
		},
		Head: {
			Filter: {
				Query: {
					maxWidth: '300px',
				},
			},
		},
		Day_title: {
			font: { weight: 'bold' },
		},
		Summary: {
			flexWrap: 'wrap',
			gap: $mol_gap.block,
			padding: $mol_gap.block,
		},
		Problems: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
			padding: { left: $mol_gap.block, right: $mol_gap.block, bottom: $mol_gap.block },
		},
		Problems_title: {
			font: { size: '1rem', weight: 'bold' },
		},
		Problem_rows: {
			flex: { direction: 'column' },
			gap: $mol_gap.text,
		},
		Problem: {
			justifyContent: 'flex-start',
			width: '100%',
			minWidth: 0,
			whiteSpace: 'normal',
			textAlign: 'left',
			overflowWrap: 'anywhere',
			color: $shm_theme.error,
			border: { width: '1px', style: 'solid', color: $mol_theme.line, radius: $mol_gap.round },
		},
		Table: {
			flex: { direction: 'column', shrink: 0 },
			overflow: 'auto',
		},
		Rows: { minWidth: '75rem' },
		Table_head: {
			minWidth: '75rem',
			display: 'grid',
			gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr) minmax(0,.9fr) minmax(0,.65fr) minmax(0,.7fr) minmax(0,.85fr) minmax(0,1.1fr) minmax(0,.9fr) minmax(0,1.25fr)',
			gap: $mol_gap.text,
			padding: $mol_gap.block,
			color: $mol_theme.shade,
			font: { size: '1rem', weight: 'bold' },
		},
		Head_ba_id: {
			minWidth: 0,
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
		},
		Row: {
			display: 'grid',
			gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr) minmax(0,.9fr) minmax(0,.65fr) minmax(0,.7fr) minmax(0,.85fr) minmax(0,1.1fr) minmax(0,.9fr) minmax(0,1.25fr)',
			minWidth: 0,
			gap: $mol_gap.text,
			padding: $mol_gap.block,
			font: { size: '1rem' },
			border: { top: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},
		Dashboard_cell: { minWidth: 0, overflowWrap: 'anywhere' },
		File: { minWidth: 0, overflowWrap: 'anywhere' },
		Client: { minWidth: 0, overflowWrap: 'anywhere', color: $mol_theme.shade },
		Period: { minWidth: 0, overflowWrap: 'anywhere' },
		Ba_id: { minWidth: 0, overflowWrap: 'anywhere' },
		State: { minWidth: 0, overflowWrap: 'anywhere' },
		Dates: { minWidth: 0, whiteSpace: 'pre-line', overflowWrap: 'anywhere' },
		Time: { minWidth: 0, whiteSpace: 'pre-line', overflowWrap: 'anywhere' },
		Error: { minWidth: 0, whiteSpace: 'pre-line', overflowWrap: 'anywhere' },
		Empty: { padding: $mol_gap.block },
	} )
}
